import { Helper } from '../../common/helpers';
import { WidgetBase } from '../../widgets';

export class DataTransactionsWidget extends WidgetBase {
    baseType = 'DataTransactions';
    col = 0;
    configuration = {};
    guid: string;
    hasExtendedProperties = true;
    highlights = [];
    icon = '';
    name = 'DataTransactions';
    row = 0;
    sizeX = 12;
    sizeY = 2;
    type = 'DataTransactions';

    constructor(name: string) {
        super();
        this.guid = Helper.getGuid();
        if (name) {
            this.name = name;
        }
    }
}